var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.noCategory)?_c('v-container',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$t('dashboard.title'))+" ")]),_c('v-divider'),_c('v-card-text',[_c('loading-card',{attrs:{"flat":""}})],1)],1)],1):_c('LibraryTestContainer')
}
var staticRenderFns = []

export { render, staticRenderFns }